/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ActiveInputs */

const th_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้งานอยู่`)
};

const en_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`active`)
};

const ja_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効`)
};

const zh_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活跃`)
};

const es_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`activa`)
};

const pt_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ativa`)
};

const id_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktif`)
};

const fr_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`active`)
};

const tl_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktibo`)
};

const vi_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đang hoạt động`)
};

const ko_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성`)
};

const de_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktiv`)
};

const ru_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`активен`)
};

const tr_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`etkin`)
};

const it_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`attivo`)
};

const pl_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktywne`)
};

const uk_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`активний`)
};

const hi_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय`)
};

const ar_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشط`)
};

const ms_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktif`)
};

const bn_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সক্রিয়`)
};

const zh_tw2_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用中`)
};

const zh_hk2_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用中`)
};

const ur_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فعال`)
};

const fa_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فعال`)
};

const sw_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hai`)
};

const nl_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actief`)
};

/**
* | output |
* | --- |
* | "active" |
*
* @param {ActiveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const active = /** @type {((inputs?: ActiveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActiveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_active(inputs)
	if (locale === "ja") return ja_active(inputs)
	if (locale === "zh") return zh_active(inputs)
	if (locale === "es") return es_active(inputs)
	if (locale === "pt") return pt_active(inputs)
	if (locale === "id") return id_active(inputs)
	if (locale === "fr") return fr_active(inputs)
	if (locale === "tl") return tl_active(inputs)
	if (locale === "vi") return vi_active(inputs)
	if (locale === "ko") return ko_active(inputs)
	if (locale === "de") return de_active(inputs)
	if (locale === "ru") return ru_active(inputs)
	if (locale === "tr") return tr_active(inputs)
	if (locale === "it") return it_active(inputs)
	if (locale === "pl") return pl_active(inputs)
	if (locale === "uk") return uk_active(inputs)
	if (locale === "hi") return hi_active(inputs)
	if (locale === "ar") return ar_active(inputs)
	if (locale === "ms") return ms_active(inputs)
	if (locale === "bn") return bn_active(inputs)
	if (locale === "zh-TW") return zh_tw2_active(inputs)
	if (locale === "zh-HK") return zh_hk2_active(inputs)
	if (locale === "ur") return ur_active(inputs)
	if (locale === "fa") return fa_active(inputs)
	if (locale === "sw") return sw_active(inputs)
	if (locale === "nl") return nl_active(inputs)
	return en_active(inputs)
});